/*** IMPORTS FROM imports-loader ***/
var require = window.require;

/* eslint-disable */
$(document).ready(function(){
  $('#requestCallTrigger').click(function() {
    require([
      'react',
      'react-dom',
      '@bingads-webui-react/request-call-modal',
      '@bingads-webui/i18n-amd-loader!shared-components/request-call-modal',
    ], function (
      React,
      ReactDom,
      RequestCallModal,
      i18n
    ) {
      var accountNumber;
      var permissions = {
        UnifiedProductSubscription: false,
      };
      var resourcePath;
      var logger;

      try {
        var pageContext = require('PageContext');
        accountNumber = pageContext.CurrentAccount && pageContext.CurrentAccount.AccountNumber;

        permissions.UnifiedProductSubscription = pageContext.Permissions && pageContext.Permissions.dynamic && pageContext.Permissions.dynamic.UnifiedProductSubscription;
        resourcePath = pageContext.SupportPagePath;
      } catch (e) { }

      if (!accountNumber) {
        try {
          var config = require('component/config/index');
          var currentAccount = config.get('CurrentAccount');
          accountNumber = currentAccount && currentAccount.AccountNumber;
        } catch (e) { }
      }

      try {
        logger = require('instrumentation/log');
      } catch (e) { }

      var close = function() {
        ReactDom.unmountComponentAtNode(document.getElementById('requestCallModalContainer'));
      };
      var modal = React.createElement(RequestCallModal.RequestCallModal, {
        isOpen: true,
        onClose: close,
        i18n: i18n,
        permissions: permissions,
        resourcePath: resourcePath,
        logger: logger,
        featureName: permissions.UnifiedProductSubscription ? 'UP' : undefined,
        context: { accountNumber: accountNumber, flowId: permissions.UnifiedProductSubscription ? 'Subscription-ads-main' : 'EXP-main-cc' }
      });
      ReactDom.render(modal, document.getElementById('requestCallModalContainer'));
    });
  });
});

